// с бэка приходит ключ в формате 'c_1230', убираем 'c_'
export const formatRowKey = (key: string) => {
  return key.replace("c_", "");
};
